export default __webpack_public_path__ + "static/media/photo-1.896c03df.jpg";